import { default as addAddressEgkciOpaEkMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/addAddress.vue?macro=true";
import { default as advancedbookingqPuTQ13zsvMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advancedbooking.vue?macro=true";
import { default as advbookingcartC1X4UXjUprMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingcart.vue?macro=true";
import { default as advbookingconfwH3Uf1BEk0Meta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingconf.vue?macro=true";
import { default as advbookingmenujZcM2KQVTgMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingmenu.vue?macro=true";
import { default as advbookingrequ8uE0PdjpsMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingreq.vue?macro=true";
import { default as advbookingsucxRpvmjCfttMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingsuc.vue?macro=true";
import { default as chooseconfirmEqkwA0a9fEMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/chooseconfirm.vue?macro=true";
import { default as choosetablevhlEOpMJh9Meta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/choosetable.vue?macro=true";
import { default as confirmbd6xydq3uHMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/confirm.vue?macro=true";
import { default as deliveryAddresshu90kxNP7xMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/deliveryAddress.vue?macro=true";
import { default as editAddress0Y11zpAd2iMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/editAddress.vue?macro=true";
import { default as historybookingpLbvme3vITMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/historybooking.vue?macro=true";
import { default as historyorderZyGgAyrFzgMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/historyorder.vue?macro=true";
import { default as indexAVMoLMsbGcMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/index.vue?macro=true";
import { default as mypageCaHibXWC6JMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/mypage.vue?macro=true";
import { default as mypagebookdetailsjruS9KmNFBMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/mypagebookdetails.vue?macro=true";
import { default as aboutusxQAtY3k1m2Meta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/aboutus.vue?macro=true";
import { default as bookcartQNvCwIyUzOMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookcart.vue?macro=true";
import { default as bookconfWferzq5qXYMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookconf.vue?macro=true";
import { default as bookinfoDT9SX24R2LMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookinfo.vue?macro=true";
import { default as bookmenupFLGVVq68QMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookmenu.vue?macro=true";
import { default as bookreqyVDutuunJWMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookreq.vue?macro=true";
import { default as booksucmQwfYsZw29Meta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/booksuc.vue?macro=true";
import { default as bookunEKHyPn3oMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book.vue?macro=true";
import { default as bookingconfj2PqfZMDqPMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingconf.vue?macro=true";
import { default as bookingdateODOB2bmz7nMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingdate.vue?macro=true";
import { default as bookinginfon0rspQyyPaMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookinginfo.vue?macro=true";
import { default as bookingmenu291dLT9swLMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingmenu.vue?macro=true";
import { default as bookingreqRPQoeYIq3pMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingreq.vue?macro=true";
import { default as bookingsucc1h9mCT5PuMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingsuc.vue?macro=true";
import { default as bookingAwxqvnJt6fMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking.vue?macro=true";
import { default as booknowVLgbpZKMEPMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booknow.vue?macro=true";
import { default as galleryYA285zhMAyMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/gallery.vue?macro=true";
import { default as homeFWdqSe9ErmMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/home.vue?macro=true";
import { default as menuslyguGQuEiMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/menu.vue?macro=true";
import { default as serviceUP6fVkvQqsMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/service.vue?macro=true";
import { default as voucherALtHjGS8t8Meta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/voucher.vue?macro=true";
import { default as vouchernowfEBuGNUZjAMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/vouchernow.vue?macro=true";
import { default as voucherPreviewWIHDQexMBIMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/voucherPreview.vue?macro=true";
import { default as navoSA7yAOE0AMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav.vue?macro=true";
import { default as orderAddresseWagGnOJ92Meta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/orderAddress.vue?macro=true";
import { default as paymentIxOlTQxyCBMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/payment.vue?macro=true";
import { default as paymentmethodseUBJx26qxFMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/paymentmethods.vue?macro=true";
import { default as paymentorderrAM5C30q1dMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/paymentorder.vue?macro=true";
import { default as popupmJtqiGphsoMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/popup.vue?macro=true";
import { default as preferenceW0npaFDMkkMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/preference.vue?macro=true";
import { default as productxSgvuOiljbMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/product.vue?macro=true";
import { default as sitemapqI8cLU8XSIMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/sitemap.vue?macro=true";
import { default as transfer58tjueEa1uMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/transfer.vue?macro=true";
import { default as userinfoB1dBYoZGgBMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/userinfo.vue?macro=true";
import { default as voucherconfr5tMyFxHwXMeta } from "/codebuild/output/src3413534337/src/ClientWebNuxt/pages/voucherconf.vue?macro=true";
export default [
  {
    name: "addAddress",
    path: "/addAddress",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/addAddress.vue")
  },
  {
    name: "advancedbooking",
    path: "/advancedbooking",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advancedbooking.vue")
  },
  {
    name: "advbookingcart",
    path: "/advbookingcart",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingcart.vue")
  },
  {
    name: "advbookingconf",
    path: "/advbookingconf",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingconf.vue")
  },
  {
    name: "advbookingmenu",
    path: "/advbookingmenu",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingmenu.vue")
  },
  {
    name: "advbookingreq",
    path: "/advbookingreq",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingreq.vue")
  },
  {
    name: "advbookingsuc",
    path: "/advbookingsuc",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/advbookingsuc.vue")
  },
  {
    name: "chooseconfirm",
    path: "/chooseconfirm",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/chooseconfirm.vue")
  },
  {
    name: "choosetable",
    path: "/choosetable",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/choosetable.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/confirm.vue")
  },
  {
    name: "deliveryAddress",
    path: "/deliveryAddress",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/deliveryAddress.vue")
  },
  {
    name: "editAddress",
    path: "/editAddress",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/editAddress.vue")
  },
  {
    name: "historybooking",
    path: "/historybooking",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/historybooking.vue")
  },
  {
    name: "historyorder",
    path: "/historyorder",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/historyorder.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/mypage.vue")
  },
  {
    name: "mypagebookdetails",
    path: "/mypagebookdetails",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/mypagebookdetails.vue")
  },
  {
    name: "nav",
    path: "/nav",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav.vue"),
    children: [
  {
    name: "nav-aboutus",
    path: "aboutus",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/aboutus.vue")
  },
  {
    name: "nav-book",
    path: "book",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book.vue"),
    children: [
  {
    name: "nav-book-bookcart",
    path: "bookcart",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookcart.vue")
  },
  {
    name: "nav-book-bookconf",
    path: "bookconf",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookconf.vue")
  },
  {
    name: "nav-book-bookinfo",
    path: "bookinfo",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookinfo.vue")
  },
  {
    name: "nav-book-bookmenu",
    path: "bookmenu",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookmenu.vue")
  },
  {
    name: "nav-book-bookreq",
    path: "bookreq",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/bookreq.vue")
  },
  {
    name: "nav-book-booksuc",
    path: "booksuc",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/book/booksuc.vue")
  }
]
  },
  {
    name: "nav-booking",
    path: "booking",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking.vue"),
    children: [
  {
    name: "nav-booking-bookingconf",
    path: "bookingconf",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingconf.vue")
  },
  {
    name: "nav-booking-bookingdate",
    path: "bookingdate",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingdate.vue")
  },
  {
    name: "nav-booking-bookinginfo",
    path: "bookinginfo",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookinginfo.vue")
  },
  {
    name: "nav-booking-bookingmenu",
    path: "bookingmenu",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingmenu.vue")
  },
  {
    name: "nav-booking-bookingreq",
    path: "bookingreq",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingreq.vue")
  },
  {
    name: "nav-booking-bookingsuc",
    path: "bookingsuc",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booking/bookingsuc.vue")
  }
]
  },
  {
    name: "nav-booknow",
    path: "booknow",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/booknow.vue")
  },
  {
    name: "nav-gallery",
    path: "gallery",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/gallery.vue")
  },
  {
    name: "nav-home",
    path: "home",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/home.vue")
  },
  {
    name: "nav-menu",
    path: "menu",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/menu.vue")
  },
  {
    name: "nav-service",
    path: "service",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/service.vue")
  },
  {
    name: "nav-voucher",
    path: "voucher",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/voucher.vue")
  },
  {
    name: "nav-vouchernow",
    path: "vouchernow",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/vouchernow.vue")
  },
  {
    name: "nav-voucherPreview",
    path: "voucherPreview",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/nav/voucherPreview.vue")
  }
]
  },
  {
    name: "orderAddress",
    path: "/orderAddress",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/orderAddress.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/payment.vue")
  },
  {
    name: "paymentmethods",
    path: "/paymentmethods",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/paymentmethods.vue")
  },
  {
    name: "paymentorder",
    path: "/paymentorder",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/paymentorder.vue")
  },
  {
    name: "popup",
    path: "/popup",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/popup.vue")
  },
  {
    name: "preference",
    path: "/preference",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/preference.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/product.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/sitemap.vue")
  },
  {
    name: "transfer",
    path: "/transfer",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/transfer.vue")
  },
  {
    name: "userinfo",
    path: "/userinfo",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/userinfo.vue")
  },
  {
    name: "voucherconf",
    path: "/voucherconf",
    component: () => import("/codebuild/output/src3413534337/src/ClientWebNuxt/pages/voucherconf.vue")
  }
]